module.exports = __webpack_public_path__ + "images/120_320.jpg";